<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { LicenseManager } from 'ag-grid-enterprise'
  LicenseManager.setLicenseKey('CompanyName=Revolution Payroll,LicensedGroup=ProBooks,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=1,LicensedProductionInstancesCount=0,AssetReference=AG-011578,ExpiryDate=4_December_2021_[v2]_MTYzODU3NjAwMDAwMA==5da9d3c2699f550dc7daf171582ca3ed')

  export default {
    name: 'app',
    data () {
      return {
        chromeWarningNotif: null
      }
    },
    methods: {
      /**
       * Determines whether the current browser being used is Chrome
       */
      checkIfBrowserIsChrome () {
        return !!window.chrome && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
      },
      /**
       * Warn user that navigating away while saving will cause data loss
       * @param event
       * @return {string}
       */
      warnUser (event) {
        if (this.shouldWarnUser) {
          let confirmationMsg = 'Refreshing this page may cause data loss'
          event.returnValue = confirmationMsg
          return confirmationMsg
        }
      }
    },
    computed: {
      ...mapGetters({
        shouldWarnUser: 'getIsUserEditingForm'
      })
    },
    created () {
      if (!this.checkIfBrowserIsChrome()) {
        const h = this.$createElement
        this.chromeWarningNotif = this.$message({
          message: h('p', null, [
            h('span', null, 'ProBooks does not currently support this browser. Please use '),
            h('a', {
              attrs: {
                href: 'https://www.google.com/chrome/',
                target: '_blank'
              }
            }, 'Chrome'),
            h('span', null, ' for an optimal experience.')
          ]),
          type: 'warning',
          duration: 0,
          showClose: true
        })
      } else {
        if (this.chromeWarningNotif) {
          this.chromeWarningNotif.close()
          this.chromeWarningNotif = null
        }
      }
    },
    mounted () {
      window.addEventListener('beforeunload', this.warnUser)
    },
    beforeDestroy () {
      window.removeEventListener('beforeunload', this.warnUser)
    }
  }
</script>

<style>
#app {
  font-family: "Roboto Condensed", "Helvetica", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}
@import '../node_modules/ag-grid-community/dist/styles/ag-grid.css';
@import '../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css';

</style>



// WEBPACK FOOTER //
// src/App.vue